import chromeExtApi from "@app/common/api/chromeExtApi";
import httpApi from "@app/common/api/httpApi";

let api;
if (import.meta.env.VITE_APP_IS_CHROME_EXT === "true") {
  api = chromeExtApi;
} else {
  api = httpApi;
}

export { default as ResponseError } from "./responseError";
export type { ApiOptions } from "./types";

export const {
  get,
  getBlobUrl,
  post,
  put,
  patch,
  httpDelete,
  uploadFile,
  rawGet,
  rawPost,
  rawPut,
  rawPatch,
  rawDelete,
  rawUploadFile,
} = api;

export default api;
